import Entity from './entity';
export default class Advert extends Entity<string> {
  imageFile:any;
  imageName:string;
  jobId:number;
  email:string;
  phoneNumber:string;
  cityId:number;
  connectionType:number;
  description:string;
  name:string;
  category:number;
  isApproved:boolean;
  selected:boolean;
  creationTime:string;
}